import { render, staticRenderFns } from "./UserSLD.vue?vue&type=template&id=4ba5bc0b&"
import script from "./UserSLD.vue?vue&type=script&lang=js&"
export * from "./UserSLD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports